import React from 'react';
//import EventEmitter from '../../../utils/emmiter';
import {UserContext} from '../../../utils/usercontext';
import BBCode from '../bbcode/bbcode';
//import {useracc, postApi} from '../../../utils/functions';

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import '../fontawesome/fontawesome';

//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

import './discord.css.map';
import './discord.css';



export default class Discord extends React.Component {
	static contextType = UserContext;
  constructor(props) {
		super(props);
    this.state = {
      messages: props.messages || [],
      deafult: props.default || ''
    };
  }

  async componentDidMount() {
  }

  render() {
    const messages = this.state.messages.map((e,i) => {
      switch(e.type) {
        case 'embed':
          return (
            <div key={i} id={i} className="dc-embed" style={{borderInlineStart: `0.25rem solid ${e.colour}`}}>
              {e.author &&
                <div className="dc-embed-author">
                  <img src="/img/dcs.svg" alt="Author" />
                  <span>discord.css</span>
                </div>
              }
              {e.thumbnail &&
                <div className="dc-embed-thumbnail">
                  <img src="/img/dcs.svg" alt="Thumbnail" />
                </div>
              }
              <div className="dc-embed-title">{e.title}</div>
              <div className="dc-embed-description"><BBCode text={e.description} whiteSpace={'pre-line'} /></div>
              {e.fields && 
                <div className="dc-embed-fields">
                  <div className="dc-embed-field-inline">
                    <div className="dc-embed-field-name">Field name</div>
                    <div className="dc-embed-field-value">Some field value</div>
                  </div>
                  <div className="dc-embed-field-inline">
                    <div className="dc-embed-field-name">Inline field name</div>
                    <div className="dc-embed-field-value">Some other field value</div>
                  </div>
                  <div className="dc-embed-field">
                    <div className="dc-embed-field-name">Field name</div>
                    <div className="dc-embed-field-value">No longer inline field</div>
                  </div>
                </div>
              }
              {e.image &&
                <div className="dc-embed-image"><img src={e.image} alt="Shadow" /></div>
              }
              {e.footer &&
                <div className="dc-embed-footer">
                  <img src="/img/dcs.svg" alt="Author Profile" />
                  <span>
                    discord.css docs
                    <span className="dc-embed-footer-seperator">•</span>
                    30.10.2023 22:13
                  </span>
                </div>
              }
            </div>
          )
        default:
          return (
            <React.Fragment key={i}></React.Fragment>
          )
      }
    });

    return (
      <>
        {messages}
      </>
    )
  }
}